'use strict';

class CXPointsArray {
    /**
     * Constructor
     * @param {int} initWithMaxSize Array max size
     */
    constructor (initWithMaxSize = 1000) {
        this._pointsArray = new Array(); // Array of points
        this._firstPoint = 0; // First point of array
        this._lastPoint = 0; // Last point of array
        this._maxSize = initWithMaxSize; // Array max size
        this._size = 0; // Current array size
    }

    /**
     * Getter - Array of points
     *
     * @readonly
     * @memberof CXPointsArray
     */
    get pointsArray () {
        return this._pointsArray;
    }

    /**
     * Add points to array of points
     * @param {int} x x coordinate
     * @param {int} y y coordinate
     * @param {int} level level of depth
     * @param {boolean} isSurounded is point surrounded
     */
    addPoint (x = x, y = y, level = level, isSurounded = isSurounded) {
        this._pointsArray[this._lastPoint] = {
            x: x,
            y: y,
            l: level,
            s: isSurounded
        };

        this._lastPoint = (this._lastPoint + 1) % this._maxSize;
        this._size += 1;
    }

    /**
     * Remove first point in array
     */
    removeFirstPoint () {
        if (this._size > 0) {
            this._firstPoint = (this._firstPoint + 1) % this._maxSize;
            this._size -= 1;
        }
    }

    /**
     * Remove range of points in array
     * @param {int} range
     */
    removeFirstPointToSize (range) {
        this._firstPoint = (range > this._size) ? this._lastPoint : (this._firstPoint + range) % this._maxSize;
        this._size = Math.max(0, this._size - range);
    }

    /**
     * Return range of points from array
     * @param {*} range
     */
    getPointsFromRange (range) {
        return this._pointsArray.slice(this._firstPoint, this._firstPoint + range);
    }

    /**
     * Get points at index
     * @param {*} index
     */
    objectAtIndex (index) {
        return this._pointsArray[(this._firstPoint + index) % this._maxSize];
    }

    /**
     * Get first point in array
     */
    firstObject () {
        return this._pointsArray[this._firstPoint];
    }

    /**
     * Length of array
     */
    count () {
        return this._size;
    }

    /**
     * Reset array properties
     */
    resetArray () {
        this._firstPoint = 0;
        this._lastPoint = 0;
        this._size = 0;
    }
}
export default CXPointsArray;
